module.exports = __webpack_public_path__ + "static/media/ultimaUmbrella.fd7813a5.png";